import { render } from "./ProgramOwner.vue?vue&type=template&id=77738870"
import script from "./ProgramOwner.vue?vue&type=script&lang=js"
export * from "./ProgramOwner.vue?vue&type=script&lang=js"

import "./ProgramOwner.vue?vue&type=style&index=0&id=77738870&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__